import CloseIcon from "../../Theme/CustomIcons/Icons/CustomIcons/CloseIcon";
import { Button, Typography } from "antd";
import HelpdeskIcon from "../../Theme/CustomIcons/Icons/CustomIcons/HelpdeskIcon";
import MessageEditIcon from "../../Theme/CustomIcons/Icons/CustomIcons/MessageEditIcon";
import ArrowLeftCircleIcon from "../../Theme/CustomIcons/Icons/Arrow/ArrowLeftCircleIcon";
import MessageQuestionIcon from "../../Theme/CustomIcons/Icons/Support,Like,Question/MessageQuestionIcon";
import { getNotificatonAction } from "../../store/action/admin/notificationsActions";
import { useDispatch, useSelector } from "react-redux";
import { css } from "@emotion/css";

const { Title, Text } = Typography;

const Menu2 = ({
  SupportButton,
  handleAction,
  setView,
  handleClose,
  token,
}) => {
  const dispatch = useDispatch();
  const tokenInfoList = useSelector((state) => state.tokenInfoList);

  const isAdmin = tokenInfoList?.info?.type?.toLowerCase() === "admin";

  const goToSupportCenter = () => {
    const baseUrl = process.env.REACT_APP_Frontend_URI;
    window.open(`${baseUrl}/admin/support-listing`, "_blank");
  };

  // ✅ NEW STYLE: Text link with icon, no border
  const GoToSupportCenterButton = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginTop: "20px",
      }}>
      <div
        onClick={goToSupportCenter}
        className={css`
          display: flex;
          align-items: center;
          gap: 8px;
          cursor: pointer;
          color: rgba(255, 255, 255, 0.65);
          font-size: 12px;
          font-weight: 500;
          letter-spacing: 0.5px;
          transition: all 0.2s ease;

          &:hover {
            color: #ffffff !important;
          }

          &:hover .support-arrow-icon {
            transform: translate(2px, -2px);
            color: #ffbb96 !important;
          }

          .support-arrow-icon {
            transition: all 0.2s ease;
            color: rgba(255, 255, 255, 0.65);
          }
        `}>
        <span>GO TO SUPPORT CENTER</span>
        <svg
          className="support-arrow-icon"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round">
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
          <polyline points="15 3 21 3 21 9" />
          <line x1="10" y1="14" x2="21" y2="3" />
        </svg>
      </div>
    </div>
  );

  return (
    <div
      style={{
        background: "rgba(0,0,0,1)",
        height: "100%",
        width: 380,
        display: "flex",
        flexDirection: "column",
      }}>
      <>
        <div
          style={{
            height: "430px",
            backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.5) 40%, rgba(0,0,0,1) 100%), url('https://catalyst-app-bucket.s3.ap-south-1.amazonaws.com/support-widget-background1.png')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            padding: "24px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
            <Text
              style={{
                color: "white",
                fontSize: "18px",
                fontWeight: 500,
              }}>
              Support Center
            </Text>
            <CloseIcon
              style={{
                color: "white",
                fontSize: "24px",
                cursor: "pointer",
              }}
              onClick={handleClose}
            />
          </div>
          <div style={{ display: "flex", gap: 12 }}>
            <ArrowLeftCircleIcon
              style={{
                color: "#d4a373",
                fontSize: "24px",
              }}
              onClick={() => {
                setView("menu");
                const companyId =
                  tokenInfoList?.info?.company?._id ??
                  tokenInfoList?.info?.companyId?._id;
                if (companyId && token) {
                  dispatch(getNotificatonAction(companyId, token));
                }
              }}
            />
            <Title
              level={2}
              style={{
                color: "#d4a373",
                margin: "8px 0 0 0",
                fontWeight: 400,
                fontSize: "24px",
              }}>
              How can we help?
            </Title>
          </div>
        </div>
        <div style={{ padding: "24px 24px 16px", flex: 1 }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "12px",
            }}>
            <SupportButton
              icon={<HelpdeskIcon size="small" />}
              label="Help & Support"
              onClick={() => handleAction("Help & Support")}
            />
            <SupportButton
              icon={<MessageQuestionIcon size="small" />}
              label="Technical Issue"
              onClick={() => handleAction("Technical Issue")}
            />
            <SupportButton
              icon={<MessageEditIcon size="small" />}
              label="Feature Request"
              onClick={() => handleAction("Feature Request")}
            />
            <SupportButton
              label="Other"
              isSmall={true}
              onClick={() => handleAction("Other")}
            />
          </div>

          {/* Go to Support Center - ADMIN ONLY */}
          {isAdmin && <GoToSupportCenterButton />}
        </div>
      </>
    </div>
  );
};

export default Menu2;
